// Routes/StudentProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useStudentAuth } from '../context/StudentAuthContext';

const StudentProtectedRoute = ({ children }) => {
  const { isAuthenticated, authLoading } = useStudentAuth();
  
  

  if (authLoading) {
    // Show loading spinner while checking auth
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/students-login" replace />;
  }

  return children;
};

export default StudentProtectedRoute;